import { render, staticRenderFns } from "./RouteDetail.vue?vue&type=template&id=1d902b5a&"
import script from "./RouteDetail.vue?vue&type=script&lang=js&"
export * from "./RouteDetail.vue?vue&type=script&lang=js&"
import style0 from "./RouteDetail.vue?vue&type=style&index=0&id=1d902b5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports